// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon_frRvx {
  background-repeat : no-repeat;
  background-size : contain;
}

.fontIcon_gEavd {
  display : inline-flex;
  align-items: center;
  justify-content:center;
}

.fontIcon_gEavd i {
  font-size: 24px;
}

.icon_frRvx, .fontIcon_gEavd {
  width : 40px;
  height : 40px;
}
  `, "",{"version":3,"sources":["webpack://./src/views/icon.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf","sourcesContent":[".icon {\n  background-repeat : no-repeat;\n  background-size : contain;\n}\n\n.fontIcon {\n  display : inline-flex;\n  align-items: center;\n  justify-content:center;\n}\n\n.fontIcon i {\n  font-size: 24px;\n}\n\n.icon, .fontIcon {\n  width : 40px;\n  height : 40px;\n}\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `icon_frRvx`,
	"fontIcon": `fontIcon_gEavd`
};
export default ___CSS_LOADER_EXPORT___;
